import compose from 'ramda/src/compose'
import prop from 'ramda/src/prop'
import split from 'ramda/src/split'

export default compose(prop(1), split('|'))
